define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Switchboard",
	"csi/api",
	"csi/def/Relationship",
	"csi/def/Toolbar",
	"csi/heading/_base",
	"csi/property/Widget",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(declare, lang, SwitchboardAction, api, Relationship, Toolbar, csiHeading, Widget, SwitchboardPlugin, xml, Query, ProductType) {

	const _reTypesOmit = /(reflist|refmap|refset|refvector)$/;

	// attribute ids that should be omitted from display
	const _omit = {
		// General
		Colors: 1,
		LocalizedName: 1,
		State: 1,

		// MarketingCollection
		BaseCurrency: 1,
		CurrencyExchangeTable: 1,
		Materials: 1,
		Products: 1,
		Segments: 1,

		// MCMaterial
		MCMaterial: 1,

		// MCProduct
		MCProductSegment: 1,
		ProductStyle: 1,

		// MCProductToCustomer
		Brands: 1,
		Features: 1,
		MCProductSizes: 1,
		MainMaterial: 1,
		RetailPrice: 1,
		WholesalePrice: 1
	};

	const _omitNoPath = {
		// General
		Code: 1,
		Description: 1,
		"Node Name": 1
	};

	const TYPES = {
		MCMaterial: {
			id: "MCMaterialType",
			type: "MaterialType"
		},

		MCProduct: {
			id: "ProductStyleType",
			type: "StyleType"
		}
	};

	function omitAttribute(key) {
		// summary: omit ref containers and other attributes hard-coded into view
		const {id, path, reflectionAttribute} = key;

		if (!id || _omit[id]) {
			return true;
		}

		const type = reflectionAttribute.valueType;
		if (!type || type.match(_reTypesOmit)) {
			return true;
		}

		// omit MCProduct/Material attributes already in view
		if (!path && _omitNoPath[id]) {
			return true;
		}

		return false;
	}

	const _Switchboard = declare(SwitchboardPlugin, {
		resDefault: "SelectAll",
		style: "margin: 0 3px",

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: update prefNodeContext with name of ProductType
			view.prefNodeContext = node ? node.$Name : null;
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: create relationship for published ProductTypes
			r = r || lang.mixin(new Relationship(), {
				m_typeNode: this.actionToolbar.view._catalogParams.type,
				m_query: new Query()
					.Attr("Published", xml.OP_EQUALS, true)
					.Attr("Available", xml.OP_EQUALS, true, "Child:ProductionConfig")
			});

			return this.inherited(arguments, [url, r]);
		}
	});

	return declare(Widget, {
		customViewOptionsComponent: null,
		disableCustomViewToolbar: true,

		// String[]: reset plugins to be filled in later
		plugins: [],

		// Boolean: indicate we only want to work with shared custom views
		prefSiteOnly: true,

		// String: specify empty context to override default Html view context so that Catalog view will find default
		prefViewContext: "",

		// Object: parameters for view
		_catalogParams: null,

		/**
		 * @override
		 * Fix view to portrait. Setting printOrientation to portrait does not work as the custom view resets it to the default.
		 */
		getPrintOrientation: function() {
			return api.PORTRAIT;
		},

		getCustomViewNodeContextsStore: function() {
			// summary: return store of product types
			return ProductType.store(this._catalogParams.type);
		},

		/**
		 * @override
		 * Render large attributes in special way
		 */
		onContext: function(ctx) {
			ctx.setParam(csiHeading.CTX_LARGE_FORMAT, true);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Disallow some attributes
		 */
		onCustomViewAttributeOptions(options) {
			options.omitAttributeCallback = omitAttribute;
			this.inherited(arguments);
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: prefNodeContext needs to vary based on product type
			this._catalogParams = TYPES[this.defView.getTypeNode()];
			this.prefNodeContext = ProductType.name(node, this._catalogParams.id);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Custom views are enabled even though disabling standard custom view toolbar controls
		 */
		supportsCustomViews: function() {
			return true;
		},

		_resolveView: function() {
			// summary: add toolbar plugin to select style type if in configuration view
			if (this.getViewNode()) {
				this.hideEmptyValues = true;
			} else {
				this.defView.defToolbar = lang.mixin(new Toolbar(), {
					m_actions: [
						lang.mixin(new SwitchboardAction(), {
							m_id: "SelectProductType",
							classToolbarPlugin: _Switchboard,
							classController: "csi/view/RefreshCustomViewController"
						}),
						"|",
						"CustomViewManageButton",
						"CustomViewSelect"
					]
				});
			}

			this.inherited(arguments);
		}
	});
});